
// /role/list
import axios from './../api' // 倒入 api

//开始实时流推送
const getVideoStream = (deviceId,params) => {
  return axios({
    url: `/api/command/realavideoTransport/${deviceId}`,
    method: 'GET',
    params
  })
}

//开始回放流推送
const startReplayStream = (deviceId,data) => {
  return axios({
    url: `/api/command/videoPlayback/${deviceId}`,
    method: 'POST',
    data
  })
}

const replayVideoControl = (deviceId,data) => {
  return axios({
    url: `/api/command/videoPlaybackcontroll/${deviceId}`,
    method: 'POST',
    data
  })
}

const closeVideoStream = (deviceId,params) => {
  return axios({
    url: `/api/command/avideo/close/${deviceId}`,
    method: 'GET',
    params
  })
}

const switchVideoStream = (deviceId,params) => {
  return axios({
    url: `/api/command/switch/stream/${deviceId}`,
    method: 'GET',
    params
  })
}

const getReplayVideoList = (data) => {
  return axios({
    url: `/api/replay/avideo`,
    method: 'POST',
    data
  })
}

const getVideoCalendar = (data) => {
  return axios({
    url: `/api/replay/avideo/calendar`,
    method: 'POST',
    data
  })
}

//上传视频
const uploadVideo = (terminalId,data) => {
  return axios({
    url: `/api/command/video/upload/${terminalId}`,
    method: 'POST',
    data
  })
}

//关闭所有直播流
const closeAllStream = (hardwareId) => {
  return axios({
    url: `/api/command/avideo/allclose/${hardwareId}`,
    method: 'GET',
  })
}
// 默认全部倒出
// 根绝需要进行
export default {
  getVideoStream,
  startReplayStream,
  replayVideoControl,
  closeVideoStream,
  switchVideoStream,
  getReplayVideoList,
  getVideoCalendar,
  closeAllStream,
  uploadVideo
}
